// src/components/Navbar.jsx
import { useState, useRef, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useLang } from '../context/LanguageContext';
import './Navbar.css';

export default function Navbar({ onDonate }) {
  const { t, lang, changeLang } = useLang();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [langDropOpen, setLangDropOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const langRef = useRef(null);
  const isHome = location.pathname === '/' || location.pathname === '/home';

  useEffect(() => {
    const handler = (e) => { if (langRef.current && !langRef.current.contains(e.target)) setLangDropOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const handleNavLink = (hash) => {
    setMobileOpen(false);
    if (isHome) {
      document.querySelector(hash)?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/' + hash);
    }
  };

  const navLinks = [
    { key: 'nav.home', hash: '#home' },
    { key: 'nav.about', hash: '#about' },
    { key: 'nav.mission', hash: '#mission' },
    { key: 'nav.team', hash: '#team' },
    { key: 'nav.media', hash: '#media' },
    { key: 'nav.contact', hash: '#contact' },
  ];

  return (
    <nav className="navbar">
      <div className="nav-container">
        <Link to="/" className="logo" onClick={() => setMobileOpen(false)}>
          <div className="logo-icon">
            <img src="/images/logo.jpeg" alt="WACEAS Logo" onError={(e) => { e.target.style.display = 'none'; e.target.parentElement.innerHTML = '👩‍👧'; }} />
          </div>
          <div className="logo-text">
            <h3 className="logo-abbrev">WACEAS</h3>
            <p className="logo-fullname">Women And Child Empowerment Association</p>
          </div>
        </Link>

        <ul className="nav-links">
          {navLinks.map(({ key, hash }) => (
            <li key={key}>
              <button className="nav-link-btn" onClick={() => handleNavLink(hash)}>
                {t(key)}
              </button>
            </li>
          ))}
          <li>
            <div className="language-selector" ref={langRef}>
              <button className="lang-switcher" onClick={() => setLangDropOpen(v => !v)} aria-label="Switch language">
                <i className="fas fa-globe"></i>
                <span>{lang.toUpperCase()}</span>
                <i className="fas fa-chevron-down" style={{ fontSize: '0.75rem', marginLeft: 4 }}></i>
              </button>
              {langDropOpen && (
                <div className="language-dropdown">
                  {['en', 'fr', 'es'].map(l => (
                    <div key={l} className={`language-option${lang === l ? ' active' : ''}`} onClick={() => { changeLang(l); setLangDropOpen(false); }}>
                      {l === 'en' ? 'English' : l === 'fr' ? 'Français' : 'Español'}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </li>
          <li>
            <button className="btn-donate" onClick={onDonate}>
              <i className="fas fa-heart"></i>
              <span className="donate-text-full">{t('donate.nav')}</span>
            </button>
          </li>
          <li>
            <Link to="/join-us" className="btn-primary" onClick={() => setMobileOpen(false)}>
              {t('nav.join')}
            </Link>
          </li>
        </ul>

        <button className="mobile-menu-btn" onClick={() => setMobileOpen(v => !v)} aria-label="Menu">
          <i className={`fas ${mobileOpen ? 'fa-times' : 'fa-bars'}`}></i>
        </button>
      </div>

      {mobileOpen && <div className="mobile-menu-backdrop" onClick={() => setMobileOpen(false)} />}
      <div className={`mobile-menu${mobileOpen ? ' active' : ''}`}>
        {navLinks.map(({ key, hash }) => (
          <button key={key} className="mobile-nav-btn" onClick={() => handleNavLink(hash)}>
            {t(key)}
          </button>
        ))}
        <div style={{ marginTop: '1rem' }}>
          <h5 style={{ color: 'var(--primary)', marginBottom: '0.5rem' }}>Language</h5>
          <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
            {['en', 'fr', 'es'].map(l => (
              <button key={l} className={`lang-switcher mobile-lang-option${lang === l ? ' active' : ''}`} onClick={() => { changeLang(l); setMobileOpen(false); }}>
                {l === 'en' ? 'English' : l === 'fr' ? 'Français' : 'Español'}
              </button>
            ))}
          </div>
        </div>
        <button className="btn-donate" onClick={() => { onDonate(); setMobileOpen(false); }} style={{ width: '100%', justifyContent: 'center', marginTop: '1rem' }}>
          <i className="fas fa-heart"></i>
          <span>{t('donate.nav')}</span>
        </button>
        <Link to="/join-us" className="btn-primary" onClick={() => setMobileOpen(false)} style={{ marginTop: '0.5rem', justifyContent: 'center' }}>
          {t('nav.join')}
        </Link>
      </div>
    </nav>
  );
}
